import {
  Component,
  Inject,
  Optional,
} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {AvisHelper} from '../avis-helper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {StateEnum} from '../../../common/services';

@Component({
  selector: 'app-avis-ms',
  templateUrl: './avis-ms.component.html',
  styleUrls: ['./avis-ms.component.scss']
})
export class AvisMsComponent extends AvisHelper {
    constructor(public formBuilder: UntypedFormBuilder,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() public dialogRef: MatDialogRef<AvisMsComponent>) {
    super(formBuilder);
    this.avisConcerned = StateEnum.masse_salariale;
    this.initAvisFormGroup();
  }
}
